import React, { Component } from 'react';
import { Button, Col, Form, Row } from 'antd';
import { Link } from 'react-router';
import { queryMaterialBorrowMyList } from '@api/administrative/material';
import '../../expenses.less';
import { connect } from 'react-redux';
import { setBackInfo } from '@store/modules/back_info';
import FormSearch from '../../FormSearch';
import TableExpenses from './TableExpenses';

class Manage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: {
        list: [],
        loading: false,
        pagination: {},
      },
    };
  }

  componentWillMount() {
    this.type = '0';
  }

  componentDidMount() {
    this.searchCondition = {};
    const { backInfo } = this.props;
    if (backInfo.path === this.props.route.path) {
      backInfo.start && backInfo.limit && (this.current = backInfo.start);
      backInfo.start &&
        backInfo.limit &&
        (this.pagination = {
          limit: backInfo.limit,
          start: backInfo.start,
        });

      backInfo.beginDate && (this.searchCondition.beginDate = backInfo.beginDate);
      backInfo.condition && (this.searchCondition.condition = backInfo.condition);
      backInfo.endDate && (this.searchCondition.endDate = backInfo.endDate);
    }
    this.loadData();
  }

  componentWillUnmount() {
    const params = {
      path: this.props.route.path,
      ...this.searchCondition,
      ...this.pagination,
    };
    this.props.dispatch(setBackInfo(params));
  }

  setTableData = res => {
    this.setState({
      dataSource: {
        list: res.data,
        pagination: {
          total: res.totalSize,
          pageSize: 15,
          current: this.current,
        },
      },
    });
  };

  handleTableChange = pagination => {
    this.pagination = {
      limit: pagination.pageSize,
      start: pagination.current,
    };
    this.current = pagination.current;
    this.loadData();
  };

  handleSearch = params => {
    this.searchCondition = {
      ...params,
    };
    this.current = 1;
    this.pagination = {
      start: 1,
    };
    this.loadData();
  };

  handleChange = val => {
    this.type = val;
    this.setState({});
    this.current = 1;
    this.pagination = {
      start: 1,
    };
    this.loadData();
  };

  getMaterialBorrowMyList = params => {
    this.setState({ loading: true });
    queryMaterialBorrowMyList(params).then(res => {
      if (res.statusCode === 200) {
        this.setTableData(res);
      }
      this.setState({ loading: false });
    });
  };

  loadData = () => {
    const params = {
      ...this.searchCondition,
      ...this.pagination,
    };
    this.getMaterialBorrowMyList(params);
  };

  render() {
    const { loading, dataSource } = this.state;
    const parentProps = {
      loading,
      dataSource,
      type: 'mine',
      onChange: this.handleTableChange,
    };
    return (
      <div>
        <Row>
          <Col span={5}>
            <Link to="/administrative/material/borrow_manage/add">
              <Button type="primary">申请资料借用</Button>
            </Link>
          </Col>
          <Col span={19}>
            <FormSearch
              onChange={this.handleChange}
              onSearch={this.handleSearch}
              {...this.searchCondition}
            />
          </Col>
        </Row>
        <TableExpenses {...parentProps} />
      </div>
    );
  }
}

export default connect(state => ({
  backInfo: state.back_info,
}))(Form.create({ wrappedComponentRef: true })(Manage));



// WEBPACK FOOTER //
// ./src/components/administrative/material/borrow/PageMine.js